import { ErrorResponse } from "@app/core/models";
import { LoginRequest } from "@app/mobile/modules/auth/models/login-request.model";
import { LoginResponse } from "@app/shared/models/auth/login-response.model";
import { createAction, props } from "@ngrx/store";

export const Login = createAction('[MobileAuth] Login', props<{ loginRequest: LoginRequest }>());
export const LoginError = createAction('[MobileAuth] Login Error', props<{ response: ErrorResponse }>());
export const LoginSuccess = createAction('[MobileAuth] Login Success', props<{ loginResponse: LoginResponse }>());
export const Logout = createAction('[MobileAuth] Logout');